/**
 * @Description 周边配套
 */

import { FC, useEffect, useState } from 'react';
import styles from './index.module.less';
import V2Title from '@/common/components/Feedback/V2Title';
import Search from './components/Search';
import TableList from './components/TableList';
import { useMethods } from '@lhb/hook';
import { getSpotEvaluationAroundPageShare, getSpotEvaluationAroundPage } from '@/common/api/spotevaluation';
import { SpotTypeEnum } from '@/views/spotevaluation/pages/index/ts-config';
// import { useBigdataFn } from '@/common/utils/bigdata';


export interface SurroundProps {
  detail?: any;
  setSurroundingChecked?: any;
  setSurroundingOptions?: any;
  curDetail:any;
  setCurDetail:any;
  tenantId: any;
  drawerData?: any;
}

const Surround: FC<SurroundProps> = ({
  detail,
  setSurroundingChecked,
  setSurroundingOptions,
  // curSurroundDetail,
  setCurDetail,
  tenantId,
  drawerData,
  ...props
}) => {
  // const bigdataFn = useBigdataFn(); // 使用埋点 Hook
  const [filters, setFilters] = useState<{ [x: string]: any }>({});// 查询条件
  const [refreshCurrent, setRefreshCurrent] = useState<boolean>(false);// 是否需要当前页刷新
  const [tableLoading, setTableLoading] = useState<boolean>(true);// 是否需要当前页刷新
  const [isNoData, setIsNodata] = useState<boolean>(false);// 是否没数据
  const [modColumn, setModColumn] = useState<any>({
    value: 'liveNum',
    label: '居住人口'
  });// 表头修改

  useEffect(() => {
    if (Object.keys(filters).length && Object.keys(detail).length) {
      setTableLoading(false);
      setSurroundingChecked && setSurroundingChecked(filters);
    }
  }, [filters, detail]);

  const methods = useMethods({

    // 搜索
    onSearch: (values: { [x: string]: string }) => {
      setFilters({ ...values });
    },

    /**
     * @description 从1页重新加载
     */
    reload() {
      setRefreshCurrent(false);
      setFilters({ ...filters });
    },

    loadData: async (params: any) => { // 初始化
      let api: any = '';
      let _params: any = {};
      // _params = {
      //   page: params.page,
      //   size: params.size,
      //   poiSearchType: 1,
      //   radius: filters.distance,
      //   lat: detail.lat,
      //   lng: detail.lng,
      //   codes: filters.codes,
      //   cityName: detail.cityName,
      //   tenantId,
      //   type: drawerData.type,
      //   modelClusterId: drawerData.modelClusterId,
      //   modelConfigId: drawerData.modelConfigId,
      // };
      const { type, modelConfigId, modelClusterId, radius } = drawerData;
      _params = {
        page: params.page,
        size: params.size,
        poiSearchType: 1,
        lat: detail.lat,
        lng: detail.lng,
        aoiTypeCategoryId: filters.aoiTypeCategoryId,
        secondAoiType: filters.secondAoiType,
        cityName: detail.cityName,
        type,
        modelConfigId,
        radius, // 先兼容接口在type2时也要求传radius的报错
      };
      if (type === SpotTypeEnum.Mall) {
        _params.modelClusterId = modelClusterId;
        _params.radius = filters.distance;
      }
      if (type === SpotTypeEnum.Street) {
        _params.radius = radius;
      }
      if (tenantId) {
        _params.tenantId = tenantId;
      }
      api = tenantId ? getSpotEvaluationAroundPageShare : getSpotEvaluationAroundPage;

      const data = await api(_params, false);
      const { objectList } = data;

      // isCommunity判断是否小区
      setModColumn(objectList?.find(item => item?.isCommunity) ? { value: 'liveNum', label: '居住人口' } : { value: 'address', label: '地址' });



      return {
        dataSource: objectList.map((item, index) => {
          item.index = (params.page - 1) * params.size + index + 1;
          return item;
        }),
        count: data.totalNum,
      };

    },
  });

  return isNoData ? <></> : (
    <div className={styles['store']} >
      <V2Title divider type='H2' text={`周边配套`}/>
      <Search
        onSearch={methods.onSearch}
        detail={detail}
        setCurDetail={setCurDetail}
        setIsNodata={setIsNodata}
        setSurroundingOptions={setSurroundingOptions}
        tenantId={tenantId}
        drawerData={drawerData}
      />
      {!tableLoading ? <TableList
        mainHeight={521}
        filters={filters}
        onFetch={methods.loadData as any}
        refreshCurrent={refreshCurrent}
        modColumn={modColumn}
        rowClassName={(record) => {
          return record.name === props?.curDetail?.name ? 'checked pointer' : 'pointer';
        }}
        onRow={record => {
          return {
            onClick: () => {
              setCurDetail(record);
              // bigdataFn('6040c893-8283-4852-90af-421553b6bb5a', '详情-周边配套-点击列表', '点击了详情-周边配套-点击列表', { op_block: '开店区域-详情页', op_event: ``, });
            }, // 点击行
          };
        }}
        onPaginationChange={() => {
          // bigdataFn('aea6572d-e826-424d-9ba0-ef71e7b79852', '详情-周边配套-列表跳页', '点击了详情-周边配套-列表跳页', { op_block: '开店区域-详情页', op_event: ``, });
        }}
      /> : ''}
    </div>
  );
};

export default Surround;
